// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] + "." + {"506":"e807eaca","536":"1c573d4f","889":"ff19ed4a"}[chunkId] + ".js";
};